module.exports = "<div class=\"welcome-screen\">\n    <h4>Things are all set</h4>\n    <p>Your password has been set successfully.</p>\n    <p>Start your journey with rapidInspect by signing in below.</p>\n    <button [routerLink]=\"['/signin']\">sign in</button>\n    <div class=\"logoimg\">\n      <img src=\"../../assets/images/logo-new.svg\">\n      </div>\n  </div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/welcome-screen/welcome-screen.component.html
// module id = ./src/app/welcome-screen/welcome-screen.component.html
// module chunks = main